import routerOptions0 from "/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}